import { JourneyTrack } from "../journey-track";
import { TrackTypes } from "../model/track-types";
import { TrackInfo } from "../model/track-info";
import { TrackActionResult } from "../model/track-action-result";

export class FirstAccessTrack extends JourneyTrack {

  track = [new TrackInfo("first-access-screen", ["first-access-screen"])];

  constructor() {
    super();
  }

  getTrack(): TrackInfo[] {
    return this.track;
  }

  getName(): TrackTypes {
    return TrackTypes.FIRST_ACCESS;
  }

  async loadData() {
    throw new Error("Method not implemented.");
  }

  executeAction(actionName: any, data: any): TrackActionResult {
    throw new Error("Method not implemented.");
  }

  isUncoupled() {
    return false;
  }

  isEventComunicator() {
    return false;
  }

  isBackHeader() {
    return false;
  }
}
